export default __webpack_public_path__ + "static/media/vivabonito14.cb5329cc.jpg";